"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Close_1 = __importDefault(require("./Close"));
var Cry_1 = __importDefault(require("./Cry"));
var Default_1 = __importDefault(require("./Default"));
var Dizzy_1 = __importDefault(require("./Dizzy"));
var EyeRoll_1 = __importDefault(require("./EyeRoll"));
var Happy_1 = __importDefault(require("./Happy"));
var Hearts_1 = __importDefault(require("./Hearts"));
var Side_1 = __importDefault(require("./Side"));
var Squint_1 = __importDefault(require("./Squint"));
var Surprised_1 = __importDefault(require("./Surprised"));
var Wink_1 = __importDefault(require("./Wink"));
var WinkWacky_1 = __importDefault(require("./WinkWacky"));
var react_1 = require("react");
var AvatarContext_1 = __importDefault(require("../../AvatarContext"));
var EyeType_1 = __importDefault(require("./EyeType"));
function Eyes() {
    var type = react_1.useContext(AvatarContext_1.default).eyeType;
    switch (type) {
        case EyeType_1.default.Close:
            return jsx_runtime_1.jsx(Close_1.default, {}, void 0);
        case EyeType_1.default.Cry:
            return jsx_runtime_1.jsx(Cry_1.default, {}, void 0);
        case EyeType_1.default.Dizzy:
            return jsx_runtime_1.jsx(Dizzy_1.default, {}, void 0);
        case EyeType_1.default.EyeRoll:
            return jsx_runtime_1.jsx(EyeRoll_1.default, {}, void 0);
        case EyeType_1.default.Happy:
            return jsx_runtime_1.jsx(Happy_1.default, {}, void 0);
        case EyeType_1.default.Hearts:
            return jsx_runtime_1.jsx(Hearts_1.default, {}, void 0);
        case EyeType_1.default.Side:
            return jsx_runtime_1.jsx(Side_1.default, {}, void 0);
        case EyeType_1.default.Squint:
            return jsx_runtime_1.jsx(Squint_1.default, {}, void 0);
        case EyeType_1.default.Surprised:
            return jsx_runtime_1.jsx(Surprised_1.default, {}, void 0);
        case EyeType_1.default.Wink:
            return jsx_runtime_1.jsx(Wink_1.default, {}, void 0);
        case EyeType_1.default.WinkWacky:
            return jsx_runtime_1.jsx(WinkWacky_1.default, {}, void 0);
        default:
            return jsx_runtime_1.jsx(Default_1.default, {}, void 0);
    }
}
exports.default = Eyes;
